const colors = {
  WHITE: '#FFFFFF',
  BLACK: '#000000',
  PRIMARY_BLUE: '#0194d3',
  NAVY_BLUE: '#003b58',
  DARKEST_NAVY_BLUE: '#01324DFF',
  DARKEST_GREY: '#58595b',
  MEDIUM_GREY: '#77787b',
  LIGHT_GREY: '#d1d3d4',
  LIGHTER_GREY: '#f4f4f4',
  PAGE_BACKGROUND: '#F6F7F9',
  BLACK_TXT: '#283237',
  ICON_GREY: '#a3b4c7',
  ORANGE: '#e98832',
  ORANGE_LIGHT: '#fcbb6d',
  GREEN: '#8dc63f',
  GREEN_LIGHT: '#bad980',
  HOVER_BLUE: '#386e89',
  LIGHT_BLUE: '#e0f1f9',
  FADED_BLUE: '#b3dff2',
  FADED_ORANGE: '#fdd6a7',
  FADED_GREEN: '#d6e8b3',
  FADED_RED: '#ffbcbc',
  RED_ERROR: '#FF0000',
  CELL_BLUE_1: '#B2DFF5',
  CELL_BLUE_2: '#DDF4FF',
  PLACEHOLDER_TEXT: '#DCDDDE',
  REJECTED: '#EB9C9C',
  PROCESSED: '#36B0E4'
};

export default colors;
